import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse, SiteType } from 'app/shared/types';
import { environment } from 'environment/environment';
import { BaseApiService } from './base-api.service';

@Injectable({
  providedIn: 'root',
})
export class SiteTypesService extends BaseApiService<
  ApiResponse<{ siteTypes: SiteType[] }>,
  ApiResponse<{ siteType: SiteType }>,
  SiteType
> {
  constructor(public override http: HttpClient) {
    super(http, environment.siteManagementApiBaseUrl);
  }

  public override controllerName(): string {
    return 'api/site-types';
  }
}
